const Tafgeet = require('tafgeetjs');

export function numberToArabic(value: number): string {
  if(!value) return '';
  const currencyInArabic: string = new Tafgeet(value.toFixed(2), 'SAR').parse();
  return currencyInArabic;
}